import { getLogs } from "../../services/api";

const state = {
  logs: [],
};
// getters
const getters = {
  getTotalSensors: (state, getters, rootState, rootGetters) =>
    rootGetters["user/getUserObj"]
      ? [].concat.apply(
          [],
          (rootGetters["user/getUserObj"].groups || []).map((gr) => gr.sensors)
        )
      : null,
  getLogs: (state) => state.logs,
};

// actions
const actions = {
  async fetchLogs({ getters, commit }) {
    const logs = await getLogs(undefined, "threshold-alert", undefined);
    const sensors = getters.getTotalSensors;

    // Get the sensors, for every sensor that has "hideEui" set to true, change the eui in the logs to the sensor custom name.
    logs.forEach((log) => {
      let sensor;
      for (let i = 0; i < sensors.length; i++) {
        console.log(sensors[i].device, log.payload.device);
        if (sensors[i].device === log.payload.device) {
          sensor = sensors[i];
          break;
        }
      }
      if (sensor) {
        if (sensor.hideEui && sensor.userConfig.name) {
          log.eui = sensor.userConfig.name;
        } else {
          log.eui = sensor.eui;
        }
      }
    });

    commit("SET_LOGS", logs);
  },
};

// mutations
const mutations = {
  SET_LOGS: (state, logs) => (state.logs = logs),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
